<dx-tabs
    [dataSource]="tabs"        
    [scrollByContent]="true"        
    [selectedIndex]="selectedIndex"        
    [showNavButtons]="true"       
    (onItemClick)="selectTab($event)">   
</dx-tabs>
<div>
    <ng-container *ngIf="selectedIndex==0">
        <highcharts-chart
            *ngIf="chartOptions11"
            class="container4"                      
            [Highcharts]="Highcharts"
            [options]="chartOptions11" [ngStyle]="{'width':width}"                      
            style="height: 500px;display:block;">
        </highcharts-chart>
        <br><br><br>
        <highcharts-chart
            *ngIf="chartOptions60"
            class="container4"                      
            [Highcharts]="Highcharts"
            [options]="chartOptions60" [ngStyle]="{'width':width}"                      
            style="height: 500px;display:block;">
        </highcharts-chart>
    </ng-container>
    <ng-container *ngIf="selectedIndex==1">
        <highcharts-chart
            *ngIf="chartOptions64"
            class="container4"                      
            [Highcharts]="Highcharts"
            [options]="chartOptions64" [ngStyle]="{'width':width}"                      
            style="height: 500px;display:block;">
        </highcharts-chart>
        <table class="table table-sm">
            <tr>
                <ng-container *ngFor="let item of detalleTablaContratacionheaders">
                    <th *ngIf="item=='financiador'">
                        {{item}}
                    </th>
                </ng-container>
                <ng-container *ngFor="let item of detalleTablaContratacionheaders">
                    <th *ngIf="item!='financiador'">
                        {{item}}
                    </th>
                </ng-container>
            </tr>
            <tr *ngFor="let item of detalleTablaContratacion">
                <td>
                    {{item['financiador']}}
                </td>
                <ng-container *ngFor="let key of detalleTablaContratacionheaders">
                    <td *ngIf="key!='financiador'">
                        {{item[key]}}
                    </td>
                </ng-container>
                
            </tr>
        </table>
    </ng-container>
    <ng-container *ngIf="selectedIndex==2">
        <highcharts-chart
            class="container4"   
            *ngIf="chartOptions1"                   
            [Highcharts]="Highcharts"
            [options]="chartOptions1" [ngStyle]="{'width':width}"                      
            style="height: 500px;display:block;">
        </highcharts-chart>
        <br> <br> <br>
        <highcharts-chart
            *ngIf="chartOptions2"
            class="container4"                      
            [Highcharts]="Highcharts"
            [options]="chartOptions2" [ngStyle]="{'width':width}"                      
            style="height: 500px;display:block;">
        </highcharts-chart>
    </ng-container>
    
</div>

<dx-popup
        [width]="300"
        [height]="250"
        [showTitle]="false"
        title=""
        fullScreen="true"
        [dragEnabled]="false"
        [closeOnOutsideClick]="true"
        [(visible)]="popupVisible">
        <div *dxTemplate="let data of 'content'">
            <div style="text-align: right;">
                <div style="float:left; font-size: 18px;font-weight: bold;line-height: 2;">
                  
                </div>
                <dx-button 
                  id="button"
                  icon="close"
                  (onClick)="popupVisible=false;">
                </dx-button>
              </div>
            <dx-scroll-view width="100%" height="100%">
                <div *ngIf="popupVisible">
                    <div class="table-responsive">
                        <table class="table table-sm">
                            <tr>
                                <th *ngFor="let item of headers">
                                    {{item}}
                                </th>
                            </tr>
                            <tr *ngFor="let item of dataTable">
                                <td *ngFor="let key of headers">
                                    {{item[key]}}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </dx-scroll-view>
            
        </div>
    </dx-popup>





// WEBPACK FOOTER //
// ./src/app/pages/report/externo-charts/externo-charts.component.html